import { useState, useEffect } from 'react';
import { updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import LockIcon from '@mui/icons-material/Lock';
import SaveIcon from '@mui/icons-material/Save';
import './User.css';

const PasswordChange = () => {
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const { isAuthenticated, userId, logout, token } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) { logout(); }
    }, [isAuthenticated, token]);

    const validatePassword = () => {
        if (newPassword.length < 8) { setErrorMessage('Password must be at least 8 characters long.'); return false; }
        if (!/[A-Z]/.test(newPassword)) { setErrorMessage('Password must contain at least one uppercase letter.'); return false; }
        if (!/[a-z]/.test(newPassword)) { setErrorMessage('Password must contain at least one lowercase letter.'); return false; }
        if (!/\d/.test(newPassword)) { setErrorMessage('Password must contain at least one digit.'); return false; }
        if (newPassword !== confirmPassword) { setErrorMessage('Passwords do not match.'); return false; }
        setErrorMessage('');
        return true;
    };

    const handleChangePassword = () => {
        if (!validatePassword()) return;
        updateData('UserTokenApi', `${userId}`, {
            CurrentPassword: oldPassword, NewPassword: newPassword,
            ConfirmPassword: confirmPassword, UserId: userId,
        }, token)
            .then((response) => {
                setSuccessMessage(response.message);
                setErrorMessage('');
                if (response.responseCode === '1111') logout();
            })
            .catch((e) => { console.error('Password Change error:', e); setErrorMessage('Error changing password.'); setSuccessMessage(''); });
    };

    return (
        <div className="user-container">
            <div className="user-header-card">
                <div className="user-header-content">
                    <div className="user-title-section">
                        <span className="user-title-icon"><LockIcon fontSize="small" /></span>
                        <h1 className="user-title">Password Change</h1>
                    </div>
                    <div className="user-header-actions">
                        <button className="usr-btn usr-btn-create" onClick={handleChangePassword}>
                            <SaveIcon style={{ fontSize: 14 }} />&nbsp;Change Password
                        </button>
                    </div>
                </div>
            </div>

            {errorMessage && <div className="user-alert user-alert-error">{errorMessage}</div>}
            {successMessage && <div className="user-alert user-alert-success">{successMessage}</div>}

            <div className="user-form-card" style={{ maxWidth: '480px' }}>
                <p className="user-form-section-title">Update Password</p>
                <div className="user-form-row" style={{ flexDirection: 'column' }}>
                    <div className="user-form-group">
                        <label className="user-label">Old Password <span className="required">*</span></label>
                        <input className="user-input" type="password" value={oldPassword} onChange={(e) => setOldPassword(e.target.value)} placeholder="Enter old password" />
                    </div>
                    <div className="user-form-group">
                        <label className="user-label">New Password <span className="required">*</span></label>
                        <input className="user-input" type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} placeholder="Enter new password" />
                    </div>
                    <div className="user-form-group">
                        <label className="user-label">Confirm Password <span className="required">*</span></label>
                        <input className="user-input" type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} placeholder="Confirm new password" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PasswordChange;
